var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{ref:"chart",attrs:{"height":"350","type":"bar","options":_vm.chartOptions,"series":_vm.series,"height":_vm.chartHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }